import React from 'react';

import LimitedTextField from '../../Shared/LimitedTextField';

const labelClass = 'block mb-1 text-[11px] font-semibold text-main-normal tracking-[0.5px]';
const textareaClass = 'w-full block bg-transparent border-0 outline-none resize-none p-0 text-sm text-main-normal box-border';
const inputWrapClass = 'block w-full box-border px-3 py-2 rounded-lg border border-panels-normal transition-colors focus-within:border-classic-button-normal focus-within:border-2 focus-within:px-[11px] focus-within:py-[7px]';

const NameField = ({value, onChange, originalValue, label = 'NAME', limit = 500, 'data-testid': testId}) => (
    <div>
        <label className={labelClass}>{label}</label>
        <div className={inputWrapClass}>
            <LimitedTextField
                data-testid={testId}
                className={textareaClass}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                readOnly={false}
                multiline
                isTextAreaAutoSize
                originalValue={originalValue}
                limit={limit}
            />
        </div>
    </div>
);

export default NameField;
